import {DateTimeFormatter, LocalDate, LocalDateTime, ZonedDateTime, ZoneId,} from '@js-joda/core';
import { Locale, } from '@js-joda/locale_en-us';
import { DateFormatter, getLocalTimeZone,} from '@internationalized/date';

export default {

  // On Chrome/Edge this will pass. The window.navigator.userAgent contains all browser names + versions
  isSafari() {
    return import.meta.server || window.navigator.userAgent.toLowerCase().includes('safari');
  },
  isIphone() {
    return window.navigator.userAgent.toLowerCase().includes('iphone');
  },
  isSafariIphone() {
    const ua = window.navigator.userAgent.toLowerCase();
    console.log('iPhone check', ua);
    return ua.includes('iphone') && ua.includes('safari');
  },
  getUserAgent() {
    return window.navigator.userAgent.toLowerCase().split('').join('');
  },
  // make sure date needs comes in as a string for the .replace
  formatBrowserDate(date, options) {
    if (this.isSafari()) {
      return new Date(date.replace(/-/g, '/')).toLocaleDateString('en', options);
    }
    else {
      return new Date(date).toLocaleDateString('en', options);
    }
  },

  /**
   *
   * @param date
   * @param inputPattern must be the format of the dateTime passed in
   * @returns {string|null}
   */
  formatUTCasLocalDateTimeString(date, inputPattern) {

    let localTime;

    try {

      // if no TIME is included since this is for dateTIME, set to .asStartOfDay
      if (!date.toString().includes(':')) {
        localTime = ZonedDateTime.of(
          LocalDate.parse(date, DateTimeFormatter.ofPattern(inputPattern).withLocale(Locale.US)).atStartOfDay(),
          ZoneId.of(ZoneId.systemDefault().toString())
        ).toLocalDateTime();

      } else {
        // convert UTC date time to timezone of client
        localTime = ZonedDateTime.of(
          LocalDateTime.parse(date.toString(), DateTimeFormatter.ofPattern(inputPattern).withLocale(Locale.US)),
          ZoneId.of(ZoneId.systemDefault().toString())
        ).toLocalDateTime();
      }

      // convert to javascript date
      const d = new Date(localTime.toString().replace(/\[|\]/g, '')).toString();

      // ~*beautify*~
      const options = { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' };
      // handle safari, and split the offset
      if (this.isSafari()) {
        return new Date(d.replace(/-/g, '/')).toLocaleDateString('en', options);
      }
      else {
        return new Date(d.split('-')).toLocaleDateString('en-US', options);
      }
    }
    catch (e) {
      console.log(e);
      return null;
    }
  },

  /**
   *
   * @param date
   * @param inputPattern
   * @param outputPattern
   * @returns {string}
   */
  formatUTCasLocalDateTime(date, inputPattern, outputPattern) {


    let localTime;

    try {

      // if no TIME is included since this is for dateTIME, set to .asStartOfDay
      if (!date.toString().includes(':')) {
        localTime = ZonedDateTime.of(
          LocalDate.parse(date, DateTimeFormatter.ofPattern(inputPattern).withLocale(Locale.US)).atStartOfDay(),
          ZoneId.of(ZoneId.systemDefault().toString())
        ).toLocalDateTime();

      } else {
        // Parse the input date string using js-joda
        localTime = ZonedDateTime.of(
          LocalDateTime.parse(date, DateTimeFormatter.ofPattern(inputPattern).withLocale(Locale.US)),
          ZoneId.of(ZoneId.systemDefault().toString())
        ).toLocalDateTime();
      }

      console.log('outputPattern', outputPattern);
      // Format localTime using the outputPattern
      return localTime.format(
        DateTimeFormatter.ofPattern(outputPattern).withLocale(Locale.US)
      );
    }
    catch (error) {
      console.error('Failed to parse date:', error);
      return null; // Handle the case of invalid input
    }
  },

  // eg: February 25, 2025
  formatDateLong(date) {
    // valiDATE
    const parsedDate = date instanceof Date && !isNaN(date) ? date : new Date(date);

    if (isNaN(parsedDate)) {
      throw new Error('Invalid date provided');
    }

    const localTimeZone = getLocalTimeZone();
    return new DateFormatter('en-US', {
      dateStyle: 'long',
      timeZone: localTimeZone,
    }).format(date);
  },

  // eg: mm-dd-yyyy format
  formatDate2Digit(date) {
    // valiDATE
    const parsedDate = date instanceof Date && !isNaN(date) ? date : new Date(date);

    if (isNaN(parsedDate)) {
      throw new Error('Invalid date provided');
    }

    const localTimeZone = getLocalTimeZone();
    return new DateFormatter('en-US', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      timeZone: localTimeZone,
    }).format(parsedDate);
  },

  // eg: Apr-20, yyyy format
  formatDateShort(date) {
    // valiDATE
    const parsedDate = date instanceof Date && !isNaN(date) ? date : new Date(date);

    if (isNaN(parsedDate)) {
      throw new Error('Invalid date provided');
    }

    const localTimeZone = getLocalTimeZone();
    return new DateFormatter('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      timeZone: localTimeZone,
    }).format(parsedDate);
  },

  /**
   * Custom sorting function for TanStack Table, the only difference here from using the built-in 'datetime' sortingFn, is it handles sorting rows with missing or null dates
   * https://tanstack.com/table/v8/docs/guide/sorting
   * @param rowA
   * @param rowB
   * @param columnId
   * @returns {number}
   */
  dateSortingFn(rowA, rowB, columnId) {
    const dateA = rowA.getValue(columnId);
    const dateB = rowB.getValue(columnId);

    // Handle null or undefined values
    if (!dateA && !dateB) return 0;
    if (!dateA) return -1; // Null values are treated as lesser
    if (!dateB) return 1;

    const parsedDateA = new Date(dateA);
    const parsedDateB = new Date(dateB);

    // Compare dates
    return parsedDateA - parsedDateB;
  },

};
